<section class="signup-submit">
    <header class="text-center">
        <img src="./assets/images/legance-color.svg" routerLink="" alt="" style="max-height: 100px;">
        <hr>
        <div class="title"><h2>{{'SIGNUP.ThankYou' | translate }}</h2></div>
    </header>
    <div class="main-content pt-5 pb-5">
        <p>{{'SIGNUP.SignupInterestText' | translate }}</p>
        <h5>{{'SIGNUP.approvedSupplier' | translate }} <span routerLink=""> {{'SIGNUP.clickToLogin' | translate }}</span> </h5>
    </div>
</section>
